











































import ServiceForm from '@/components/service/ServiceForm.vue';
import ServiceUtils, { Service } from '@/utils/ServiceUtils';
import Vue from 'vue';

export default Vue.extend({
  components: { ServiceForm },

  data(): {
    state: {
      valid: boolean;
      submit: boolean;
      delete: boolean;
      errors?: any[];
    };
    item?: Partial<Service>;
  } {
    return {
      state: {
        valid: false,
        submit: false,
        delete: false,
        errors: undefined,
      },
      item: undefined,
    };
  },

  async mounted() {
    try {
      this.item = ServiceUtils.service.generateDefault(
        await ServiceUtils.service.api.get(parseInt(this.$route.params?.id))
      );
      (this.$refs.form as any).resetValidation();
    } catch (error) {
      console.error(error);
      if (error.response.status === 404) {
        // TODO: not found
      }
    }
  },

  methods: {
    async handleSubmit() {
      if (this.item) {
        try {
          this.state.errors = undefined;
          this.state.submit = true;
          (this.$refs.form as any).validate();

          this.item = ServiceUtils.service.generateDefault(
            await ServiceUtils.service.api.update(this.item)
          );

          (this.$refs.form as any).resetValidation();
          this.$toast.push({
            text: this.$t('success.edit', [this.$tc('service.label')]),
            type: 'success',
          });
        } catch (error) {
          this.$toast.push({
            text: this.$t('error.edit', [this.$tc('service.label')]),
            type: 'error',
          });
          this.state.errors = error; // TODO: handle errors
        } finally {
          this.state.submit = false;
        }
      }
    },

    async handleDelete() {
      try {
        this.state.errors = undefined;
        this.state.delete = true;
        await ServiceUtils.service.api.remove(this.item?.id as number);
        this.$toast.push({
          text: this.$t('success.delete', [this.$tc('service.label')]),
          type: 'success',
        });
        this.$router.replace({ name: 'service-list' });
      } catch (error) {
        this.$toast.push({
          text: this.$t('error.delete', [this.$tc('service.label')]),
          type: 'error',
        });
        this.state.errors = error; // TODO: handle errors
      } finally {
        this.state.delete = false;
      }
    },
  },
});
